import React, { useState, useEffect, Fragment } from "react";

const useAdminSkillsTable = (
  skillset,
  skillCatArray, 
  handleDelSkill,
  handleEditSkill,
  onClickToggleFromTable
) => {
  const [thead] = useState(["Skill Name","Skill Category Name", "Action"]);
  const [trow, setTrow] = useState([]);

  useEffect(() => {
   if (skillCatArray.length > 0){
    let trowArr = skillset.map((skilllist) => {   

      return {
        "Skill Name": skilllist.skillName,
        "Skill Category Name":  skillCatArray.filter((skillCat) => skillCat.skillCategoryId === parseInt(skilllist.skillCategoryId))[0].skillCategoryName,
        Action: (
          <Fragment>
             <i
              className="fas fa-edit ml-4"     
              style={{ marginRight: "10px", cursor: "pointer" }}         
              onClick={() => {
                handleEditSkill(skilllist, skilllist.skillId);
                onClickToggleFromTable();
             }}
            ></i>
            <i
              className="fas fa-trash"
              onClick={() => handleDelSkill(skilllist.skillId)}
            ></i>
           
          </Fragment>
        ),
      };
    });

     setTrow(trowArr);
  }}, [
    skillCatArray,
    skillset,
    handleDelSkill,
    handleEditSkill,
    onClickToggleFromTable
  ]);

  return { thead, trow };
};

export default useAdminSkillsTable;
